import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { enabled: Boolean };

  static targets = ["container", "offPosition", "onPosition"];

  toggle() {
    this.enabledValue = !this.enabledValue;

    this.render();
  }

  render() {
    this.toggleClasses(this.element, ["bg-navy-600"], this.enabledValue);
    this.toggleClasses(
      this.element,
      ["bg-gray-300", "dark:bg-gray-800"],
      !this.enabledValue,
    );

    this.toggleClasses(
      this.containerTarget,
      ["translate-x-6"],
      this.enabledValue,
    );
    this.toggleClasses(
      this.containerTarget,
      ["translate-x-0"],
      !this.enabledValue,
    );

    this.toggleClasses(
      this.offPositionTarget,
      ["opacity-0", "ease-out"],
      this.enabledValue,
    );
    this.toggleClasses(
      this.offPositionTarget,
      ["opacity-100", "ease-in"],
      !this.enabledValue,
    );

    this.toggleClasses(
      this.onPositionTarget,
      ["opacity-100", "ease-in"],
      this.enabledValue,
    );
    this.toggleClasses(
      this.onPositionTarget,
      ["opacity-0", "ease-out"],
      !this.enabledValue,
    );
  }

  toggleClasses(element, classes, enabled) {
    classes.forEach((klass) => {
      element.classList.toggle(klass, enabled);
    });
  }
}
